import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../../services/master-data.service';
import { ExitFormService } from '../../services/exit-form.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-exit-form-summary',
  templateUrl: './exit-form-summary.component.html',
  styleUrls: ['./exit-form-summary.component.css']
})
export class ExitFormSummaryComponent implements OnInit {

  exitFormSummaryList = [];

  constructor(private masterDataService: MasterDataService,
    private exitFormService: ExitFormService,
    private route: Router) { }

  ngOnInit(): void {
    this.loadInitialDetails();
  }

  articleSummaryList = [];
  employeeSummaryList = [];
  loadInitialDetails() {
    this.masterDataService.getExitFormSummaryDetails().subscribe((resp: any) => {
      console.log('exit form summary details', resp);
      this.exitFormSummaryList = resp;
      this.exitFormSummaryList.map((res: any) => {
        if (res.user.type == 'Article') {
          this.articleSummaryList.push(res);
          console.log('article form summary details', this.articleSummaryList);
        } else {
          this.employeeSummaryList.push(res);
          console.log('employee form summary details', this.employeeSummaryList);
        }
      })
    });
  }

  viewExitFormDetails(detail) {
    console.log('userdetails', detail);
    this.exitFormService.setExitForm(detail);
    this.route.navigate(['/dashboard/exit-form-detail']);
  }
}
